import React from 'react';
import './style.css';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../Main';

const Banner1 = () => {
  const { isAuth } = React.useContext(AuthContext);
  const { t } = useTranslation();
  const flagStyle = i18next.dir() === 'rtl' ? { left: '-10px', top: '-8px' } : { right: '-10px', top: '-8px' };
  const brandStyle = i18next.dir() === 'rtl' ? { paddingRight: '12%' } : { paddingLeft: '5%' };

  return (
    <div className="banner1-container">
      <div className="banner1-overlay"></div>
      <div className="d-flex w-sm-100 justify-content-sm-between align-items-center relative">
        <div className="banner1-image-container-full-opacity" style={brandStyle}>
          <img src={`/assets/images/IQRAA.png`} alt="UDL" className="library-img-colored" />
        </div>
        <div className="banner1-title-container d-flex  justify-content-center align-items-center">
          <div className="header-title-container ">
            <h1 className="header">{t('banner1.title')}</h1>
            <h3 className="title">{t('banner1.sub-title').split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < t('banner1.sub-title').split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}</h3>
            <h4 className="description-sub-title">
              {(() => {
                const text = t('banner1.title2');
                // Check for different variations of "Algerian" in different languages
                const algerianWords = ['الجزائرية', 'Algérienne', 'Algerian'];
                let foundWord = null;
                
                for (const word of algerianWords) {
                  if (text.includes(word)) {
                    foundWord = word;
                    break;
                  }
                }
                
                if (foundWord) {
                  return text.split(foundWord).map((part, index) => (
                    <React.Fragment key={index}>
                      {part}
                      {index < text.split(foundWord).length - 1 && (
                        <span className="algerian-green">{foundWord}</span>
                      )}
                    </React.Fragment>
                  ));
                }
                
                return text;
              })()}
            </h4>
          </div>
        </div>
        <div className="banner1-flag-container">
          <img src="/assets/images/algeria1.png" alt="Algeria Flag" className="algeria-flag" />
        </div>
      </div>
    </div>
  );
};

export default Banner1;
